<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <hotel-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import HotelForm from "./Form"
import model from "./model"

export default {
  components: { HotelForm },
  data() {
    return { model }
  },
}
</script>
